export default {
  computed: {
    masterAccount () {
      return this.$store.state.header?.headerData?.isMasterAccount ?? false
    }
  }
}
